import React from "react";
import BottomBar from "../Components/BottomBar";
import Footer from "../Components/Footer";
import Header from "../Components/Header.jsx";
import FloatingWhats from "../Components/FloatingWhats";
import styles from "../styles/Comercial.css"
import { Button, Grid2 } from "@mui/material";

const Comercial = () => {
    return (
        <div className="container">
            <FloatingWhats/>
            <Header/>    
            <div className="content">
                <div className="bannerInterno-container from-top">
                    <div className="bannerInterno-content">
                        <div className="bannerInterno">
                            <h1 className="bannerInterno-title">Comercial</h1>
                            <img className="bannerInterno-img comercial-logo" src="../images/logobc.svg" alt="Banner Assitência-Técnica"/>
                        </div>
                    </div>
                </div>
                <div className="abrangencia">
                    <div className="abrangencia-content">
                        <div className="abrangencia-left from-left" style={{maxWidth:'650px'}}>
                            <h3 className="abrangencia-subtitle from-left">Equipe Comercial</h3>
                            <h2 className="abrangencia-title from-left">Atendimento especializado para todo o Brasil</h2>
                            <div className="abrangencia-textBox">
                                <div className="abrangencia-bar"/>
                                <div className="abrangencia-text">
                                    <p className="abrangencia-textContent from-left">Na Balanças Cuiabá, nosso time comercial está preparado para entender sua operação e indicar a melhor solução com segurança, agilidade e conhecimento técnico.</p>
                                </div>
                            </div>
                            <a href="https://wa.me/+556599547518">
                                <Button sx={{height:60, width:315, marginTop:4, borderRadius:'8px', color:'#fff', textTransform:'none', backgroundColor:'#474747', fontWeight:'700', fontSize:'16px','&:hover':{backgroundColor:'#9E1518'}}}>Solicitar Orçamento</Button>
                            </a>
                        </div>
                        <div className="abrangencia-right from-right">
                            <img src="../images/icons/comercial-icon.svg" alt="Comercial" className="abrangencia-mapa"/>
                        </div>
                    </div>
                </div>
                <div className="horario-atendimento">
                    <div className="horario-atendimento-content from-bottom">
                        <h3 className="horario-atendimento-title">
                            <span style={{color:'#474747'}}>Atendimento </span>
                            <span style={{color:'#9E1518'}}>Comercial Consultivo</span>
                        </h3>
                        <div className="horario-atendimento-bar"/>
                        <span className="horario-atendimento-line3 from-bottom">Nosso setor comercial vai além da venda. Trabalhamos de forma consultiva, entendendo a realidade de cada cliente para oferecer soluções em pesagem que realmente façam sentido para sua operação.<br/>Cada projeto é analisado com atenção, considerando fatores técnicos, operacionais e normativos, garantindo uma proposta eficiente, segura e dentro das exigências do mercado.</span>
                    </div>
                </div>
                <div className="equipe">
                    <div className="equipe-content">
                        <h2 className="equipe-title from-bottom">EQUIPE <span style={{fontStyle:'italic'}}>COMERCIAL</span></h2>
                        <div className="horario-atendimento-bar from-bottom" style={{borderBottom:'2px dotted #9E1518'}}/>
                        <h4 className="equipe-text from-bottom">Nossa equipe está disponível para atender você de forma rápida e<br/>eficiente, respeitando as particularidades de cada região.</h4>
                    </div>
                    <p className="plantao-contatos from-bottom">
                        <a href="https://wa.me/+5565999547518" style={{textDecoration:'none'}}>
                            <Button sx={{fontFamily:'Inter', overflow:'hidden', display:'flex', flexDirection:'column', height:'100px', width:'270px', borderRadius:'8px', color:'#FFF', textTransform:'none', backgroundColor:'#474747', fontWeight:'700', fontSize:'20px','&:hover':{backgroundColor:'#7D1115'}}}>
                                {/* <span style={{fontStyle:'italic', fontSize:'16px', height:20}}>Norte / Centro-Oeste</span> */}
                                <span style={{fontStyle:'italic',fontSize:'22px', height:25}}>Luciano</span>
                                <span style={{fontSize:'22px'}}>(65) 99954-7518</span>
                                <img style={{position:'absolute', height:80, right:-14, opacity:0.3}} src="images/icons/whatsapp.svg"/>
                            </Button>
                        </a>
                        {/* <a href="https://wa.me/+5545999714611" style={{textDecoration:'none'}}>
                            <Button sx={{fontFamily:'Inter', overflow:'hidden', display:'flex', flexDirection:'column', height:'100px', width:'270px', borderRadius:'8px', color:'#FFF', textTransform:'none', backgroundColor:'#474747', fontWeight:'700', fontSize:'20px','&:hover':{backgroundColor:'#7D1115'}}}>
                                <span style={{fontStyle:'italic', fontSize:'16px', height:20}}>Sul / Sudeste</span>
                                <span style={{fontStyle:'italic',fontSize:'22px', height:25}}>Vinicius</span>
                                <span style={{fontSize:'22px'}}>(45) 99971-4611</span>
                                <img style={{position:'absolute', height:80, right:-14, opacity:0.3}} src="images/icons/whatsapp.svg"/>
                            </Button>
                        </a> */}
                    </p>
                </div>
                <div className="horario-atendimento">
                    <div className="horario-atendimento-content from-bottom">
                        <h3 className="horario-atendimento-title">
                            <span style={{color:'#474747'}}>Horário de </span>
                            <span style={{color:'#9E1518'}}>Atendimento</span>
                        </h3>
                        <div className="horario-atendimento-bar"/>
                        <p className="horario-atendimento-text from-bottom">
                            <span className="horario-atendimento-line1">De segunda à sexta-feira</span>
                            <span className="horario-atendimento-line2">08:00 às 12h | 13h às 17:48</span>
                        </p>
                        <span className="horario-atendimento-line3">Não atendemos aos<br/>sábados e domingos!</span>
                    </div>
                </div>
                <div className="solucoes">
                    <div className="solucoes-content">
                        
                        <h2 className="equipe-title from-bottom">SOLUÇÕES <span style={{fontStyle:'italic'}}>OFERECIDAS</span></h2>
                        <div className="horario-atendimento-bar from-bottom" style={{borderBottom:'2px dotted #9E1518'}}/>
                        <h4 className="equipe-text from-bottom">Oque podemos oferecer para sua operação</h4>
                        <Grid2 className="from-bottom" columns={{ xs:4, sm:8, md:12}} container spacing={2} justifyContent={'center'}>
                            <Grid2 item>
                                <a href='/produtos/pesagem-rodoviaria' className="solucoes-block">
                                    <span className='solucoes-block-title'>Pesagem Rodoviária</span>
                                </a>
                            </Grid2>
                            <Grid2 item>
                                <a href='/produtos/linha-industrial' className="solucoes-block">
                                    <span className='solucoes-block-title'>Automação Industrial</span>
                                </a>
                            </Grid2>
                            <Grid2 item>
                                <a href='/produtos/pesagem-rodoviaria' className="solucoes-block">
                                    <span className='solucoes-block-title'>Células de Carga</span>
                                </a>
                            </Grid2>
                            <Grid2 item>
                                <a href='/produtos/linha-industrial' className="solucoes-block">
                                    <span className='solucoes-block-title'>Ensacadoras</span>
                                </a>
                            </Grid2>
                            <Grid2 item>
                                <a href='/produtos/tulhas-e-balancas-de-fluxo' className="solucoes-block">
                                    <span className='solucoes-block-title'>Tulhas</span>
                                </a>
                            </Grid2>
                            <Grid2 item>
                                <a href='/produtos/tulhas-e-balancas-de-fluxo' className="solucoes-block">
                                    <span className='solucoes-block-title'>Balanças de Fluxo</span>
                                </a>
                            </Grid2>
                            <Grid2 item>
                                <a href='/produtos/linha-industrial' className="solucoes-block">
                                    <span className='solucoes-block-title'>Balanças de Baixo Perfil</span>
                                </a>
                            </Grid2>
                            <Grid2 item>
                                <a href='/assistencia-tecnica' className="solucoes-block">
                                    <span className='solucoes-block-title'>Assistência Técnica 24h</span>
                                </a>
                            </Grid2>
                        </Grid2>
                        
                        
                    </div>
                </div>









                <BottomBar/>
                <Footer/>
            </div>
        </div>
    )
}
export default Comercial;